import React from 'react'
import PropTypes from 'prop-types'
import { choosePhoneNumberFormatter } from '../../../services/formatters'
import List from './List'
import Header from './Header'

const ContactListView = ({
  contacts,
  conversionStats,
  onFilterChange,
  filterValue,
  handleContactEdit,
}) => (
  <div className="contactsWrapper">
    <Header
      onFilterChange={onFilterChange}
      filterValue={filterValue}
      conversionStats={conversionStats}
    />
    {
      !contacts || contacts.length < 1 ? (
        <div className="contactsWrapper">
          <h2>No Results Found</h2>
          <h4>Change the selected filters to adjust your search criteria</h4>
        </div>
      ) : (
        <List
          formatPhoneNumber={choosePhoneNumberFormatter('US')}
          key="list"
          contacts={contacts}
          handleContactEdit={handleContactEdit}
        />
      )
    }
  </div>
)

ContactListView.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object).isRequired,
  conversionStats: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filterValue: PropTypes.string.isRequired,
  handleContactEdit: PropTypes.func.isRequired,
}

export default ContactListView



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactsTab/View.js